import * as UI from "@iyk/ui"
import * as React from "react"

import { Assets } from "../../../packages/assets.ts"
import { VerifiedProfileIcon } from "./icons.tsx"
import { Link, Routes } from "./link.tsx"

export const UserProfileCard = (props: UserProfileCard.Props) => {
  const hasAtLeastOneProof = props.totalCheckIns > 0 || props.totalMerchOwned > 0
  return (
    <Link
      to={Routes.collection(props.userId)}
      className="flex flex-col justify-between p-3 rounded border border-grayA-2 bg-white/[3%] h-[var(--card-height)]"
    >
      <img
        src={Assets.images.profileCardImage}
        alt="Daniel Allan Avatar"
        className="size-6 -outline-offset-1 [outline:1px_solid_rgb(0_0_0/5%)] "
      />
      {hasAtLeastOneProof ? (
        <div className="flex items-center gap-3">
          {hasAtLeastOneProof && <VerifiedProfileIcon className="size-5" />}
          <div className={classForUserLabel}>
            {props.variant === "profile" ? (
              <React.Fragment>
                <span>{props.username}</span>
                <br />
                <span>Since {props.since}</span>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <span className="text-gray-11">Owner:</span>
                <br />
                <span>{props.username}</span>
              </React.Fragment>
            )}
          </div>
        </div>
      ) : (
        <span className={classForUserLabel}>{props.username}</span>
      )}
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <UI.Icon.Location />
            <span className="text-xs font-departure-mono">{props.totalCheckIns}</span>
          </div>
          <div className="flex items-center gap-2">
            <UI.Icon.Badge />
            <span className="text-xs font-departure-mono">{props.totalMerchOwned}</span>
          </div>
        </div>
        <span className="bg-grayA-2 hover:bg-grayA-3 size-7 rounded-sm grid place-items-center">
          <UI.Icon.Eye />
        </span>
      </div>
    </Link>
  )
}

const classForUserLabel = UI.cx(
  "uppercase text-[11px] leading-[16px] tracking-upper font-departure-mono",
)

namespace UserProfileCard {
  export type Props = {
    userId: string
    username: string
    since: string
    totalCheckIns: number
    totalMerchOwned: number
    variant: "owner" | "profile"
  }
}
